<ng-container
  [appTransition]="child"
  [show]="active"
  [duration]="200"
  enter="transition-all"
  enterFrom="opacity-0"
  enterTo="opacity-100"
  leave="transition-all"
  leaveFrom="opacity-100"
  leaveTo="opacity-0"
>
  <div #child class="budget-selection">
    <app-container>
      <div class="content">
        <div class="header">
          <h2>Selecione um orçamento</h2>
          <button (click)="closed.emit()">
            <span class="pi pi-times"></span>
          </button>
        </div>
        <form class="search" [formGroup]="search">
          <app-input
            placeholder="Nome do cliente"
            formControlName="cliente"
            label="Filtrar por cliente"
          ></app-input>
        </form>
        <div class="budgets">
          <div class="error-banner" *ngIf="loadErrorMessage()">
            {{ loadErrorMessage() }}
          </div>
          <div class="budgets-table">
            <p-table
              [value]="budgets()"
              [tableStyle]="{ 'min-width': '50rem' }"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col">Obra</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">Valor</th>
                  <th scope="col">Feito em</th>
                  <th scope="col"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-budget>
                <tr>
                  <td>{{ budget.numeroOrcamento || numeroPedido(budget) }}</td>
                  <td>{{ budget.nomeCliente }}</td>
                  <td>
                    <strong>
                      {{ budget.valorTotalOrcamento | currency: "BRL" }}
                    </strong>
                  </td>
                  <td>{{ budget.dataCriacaoObra | date: "dd/MM/YYYY" }}</td>
                  <td class="button">
                    <app-button
                      (click)="selectBudget(budget)"
                      (keydown.enter)="selectBudget(budget)"
                      text="Selecionar"
                    ></app-button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="budgets-card">
            <app-budget-mobile-card
              (choose)="selectBudget(budget)"
              [budget]="budget"
              *ngFor="let budget of budgets()"
            ></app-budget-mobile-card>
          </div>
          <div class="pagination">
            <p-paginator
              (onPageChange)="onPageChange($event)"
              [first]="0"
              [rows]="query().pageSize"
              [totalRecords]="totalBudgets()"
            ></p-paginator>
          </div>
        </div>
      </div>
    </app-container>
  </div>
</ng-container>
